const navbar = () => {

  document.addEventListener("DOMContentLoaded", () => {

    const navbarSection = document.querySelector(".navbar__section");
    if (!navbarSection) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        navbarSection.classList.add("scrolled");
      } else {
        navbarSection.classList.remove("scrolled");
      }
    })

    const navbarToggler = navbarSection.querySelector(".navbar__toggler");
    if (!navbarToggler) return;

    navbarToggler.addEventListener('click', () => {
      navbarSection.classList.toggle("active");
    })

    const menuLinks = navbarSection.querySelectorAll(".menu__link");
    if (!menuLinks.length) return;
    menuLinks.forEach((link) => {
      link.addEventListener('click', () => {
        navbarSection.classList.remove("active");
      })
    });


  });


};

export default navbar;
